import { gql } from '@apollo/client';
import { loader } from 'graphql.macro';

import { VESSEL_FRAGMENT } from './vesselFragment';
import { COMPANY_FRAGMENT } from './companyFragment';
import { CARGO_QTY_FRAGMENT } from './cargoQuantityPartFragment';
import { LAYCAN_FRAGMENT } from './laycanFragment';
import { LOCATION_PART_FRAGMENT } from './locationPartFragment';
import { CARGO_PART_FRAGMENT } from './cargoPartFragment';
import { FREIGHT_PORT_BASIS_FRAGMENT } from './freightPortBasisFragment';
import { RATES_FRAGMENT } from './ratesFragment';
import { THIRD_PARTY_COMPANY_PART_FRAGMENT } from './thirdPartyCompanyPartFragment';
import { CLARKSONS_USER_FRAGMENT } from './clarksonsUserFragment';
import { DURATION_PART_FRAGMENT } from './durationPartFragment';
import { COMMISSION_FRAGMENT } from './commissionFragment';
import { VISIBILITY_FRAGMENT } from './visibilityFragment';
import { TCE_PART_FRAGMENT } from './tcePartFragment';

const FRAGMENT = loader('./fixtureFragment.gql');

export const FIXTURE_FRAGMENT = gql`
    ${CARGO_PART_FRAGMENT}
    ${FRAGMENT}
    ${VESSEL_FRAGMENT}
    ${FREIGHT_PORT_BASIS_FRAGMENT}
    ${COMPANY_FRAGMENT}
    ${CARGO_QTY_FRAGMENT}
    ${LAYCAN_FRAGMENT}
    ${LOCATION_PART_FRAGMENT}
    ${RATES_FRAGMENT}
    ${DURATION_PART_FRAGMENT}
    ${THIRD_PARTY_COMPANY_PART_FRAGMENT}
    ${CLARKSONS_USER_FRAGMENT}
    ${COMMISSION_FRAGMENT}
    ${VISIBILITY_FRAGMENT}
    ${TCE_PART_FRAGMENT}
`;
